import { HOME } from "@/constants/testIds";
import { useLang } from "@/contexts/LangContext";

// Marquee promo ticker. Rendered with safe JSX — no innerHTML.
export const PromoTicker = () => {
  const { t } = useLang();
  const items = [
    { id: "free120", text: t("promo_1") },
    { id: "bottles", text: t("promo_2") },
    { id: "daily", text: t("promo_3") },
    { id: "247", text: t("promo_4") },
    { id: "oz", text: t("promo_5") },
  ];
  // Duplicate items so the marquee loops seamlessly.
  const loop = [...items, ...items].map((it, i) => ({ ...it, key: `${it.id}-${i}` }));

  return (
    <div
      data-testid={HOME.promoBanner}
      className="relative w-full overflow-hidden border-y border-[#00ff41]/30 bg-[#00ff41] text-black"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap py-3 will-change-transform">
        {loop.map((it) => (
          <span
            key={it.key}
            className="font-display text-sm font-bold uppercase tracking-[0.18em] flex items-center gap-12"
          >
            {it.text}
            <span className="opacity-50" aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default PromoTicker;
